document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);

    // 🎯 揺れありのアニメーションを適用するセクション
    const specialSections = [
        "#Slider-template--18331426422884__multicolumn_RhmwhG img",
        "#Slider-template--18331426422884__multicolumn_Dhg9xz img"
    ];

    gsap.utils.toArray(specialSections.join(", ")).forEach((img) => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: img,
                start: "top 85%",
                end: "top 40%",
                scrub: true,
            }
        });

        // ふわっと浮かびながら登場（細かい揺れあり）
        tl.fromTo(img,
            {
                opacity: 0,
                y: 50, // 少し小さめの移動距離
                scale: 0.95,
                rotation: -2,
                x: -5, // 軽く左にズラす
            },
            {
                opacity: 1,
                y: 0,
                scale: 1,
                rotation: 0,
                x: 0,
                duration: 1.5,
                ease: "power3.out",
            }
        );

        // 細かい揺れ（途中で止まる）
        tl.to(img, {
            x: 2,
            rotation: 1.3,
            duration: 1.5,
            ease: "sine.inOut",
            repeat: 5,
            yoyo: true,
        });
    });

    // 🎯 それ以外の `main` 内の img に「ゆっくり浮かび上がる」アニメーション
    gsap.utils.toArray("main img").forEach((img) => {
        // ✅ `.bg` クラスの中の `img` は除外
        if (img.closest("#shopify-section-template--18331426422884__custom_liquid_9mbgMC .bg")) return;

        // ✅ `#shopify-section-template--18331426422884__image_with_text_LxjmeY` 内の `img` も適用除外
        if (img.closest("#shopify-section-template--18331426422884__image_with_text_LxjmeY")) return;
       // ✅ `トップビデオ内の `img` も適用除外
         if (img.closest("#shopify-section-template--18331426422884__video_H8GMzi")) return;

        // ✅ すでに `Slider-template--...` 内の `img` なら処理しない
        if (img.closest("#Slider-template--18331426422884__multicolumn_RhmwhG") ||
            img.closest("#Slider-template--18331426422884__multicolumn_Dhg9xz")) return;

        gsap.fromTo(img,
            {
                opacity: 0,
                y: 50, // 下からゆっくり登場
                scale: 0.9,
            },
            {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 1.5,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: img,
                    start: "top 85%",
                    end: "top 30%",
                    scrub: true,
                }
            }
        );
    });
});
